import './summaryCountWidget.less'
import LoaderView from '../Loader/loader'
import { humanDiskSize } from '../../utils/mathUtils'
import { SyncInfo } from '../../features/syncInfo/syncInfoSlice'
import { DATASOURCE_STATUS } from '../../constants'
import { RootState } from '../../rootReducer'
import { FormattedMessage, FormattedNumber } from 'react-intl'
import { Info as IconInfo } from 'phosphor-react'
import { Link } from 'react-router-dom'
import { Popup } from 'semantic-ui-react'
import React, { Fragment, ReactElement } from 'react'
import { Tags, Typography } from '@lightbeamai/design-system'
import { connect } from 'react-redux'

interface ISummaryItemInfo {
  text: string
  secondaryText?: string
  icon?: ReactElement
  tooltip?: string
  link?: string
  numberFormat?: boolean
}

export interface ISummaryItemWithCount extends ISummaryItemInfo {
  count?: number
  content?: never

  // convert?: (value) => humanDiskSize(value)
}
export interface ISummaryItemWithContent extends ISummaryItemInfo {
  count?: never
  content?: ReactElement
}
export type ISummaryItem = ISummaryItemWithCount | ISummaryItemWithContent

interface IProps {
  useMockData?: boolean
  summaryItems: ISummaryItem[]
  showLoader?: boolean
  syncInfo?: SyncInfo
}
const SummaryItem = ({
  icon,
  count,
  content,
  text,
  secondaryText,
  tooltip,
  numberFormat = true
}: ISummaryItem) => {
  return (
    <div className="summary-item">
      <div className="count-info">
        <div className="count-icon">{icon ? icon : ''}</div>
        <span className="count xs-pt-8">
          {content ? (
            content
          ) : numberFormat ? (
            <Typography variant="basePlus2" color="primary" className="font-600">
              <FormattedNumber value={count ?? 0} notation="compact" />
            </Typography>
          ) : (
            humanDiskSize(count ?? 0)
          )}
        </span>
        <Typography
          as="span"
          variant="baseMinus2"
          color="secondary"
          type="medium"
          className="xs-mt-4"
        >
          {tooltip ? (
            <Popup
              trigger={
                <span className="summary-tooltip">
                  {text}
                  <IconInfo
                    size={14}
                    color="var(--color-alerts-action-text)"
                    className="xs-ml-4"
                    weight="bold"
                  />
                </span>
              }
              content={tooltip}
              position="bottom right"
              size="tiny"
              inverted
            />
          ) : (
            text
          )}
        </Typography>
      </div>
      {secondaryText ? (
        <Typography as="span" variant="baseMinus4" color="secondary" className="secondary-text">
          {secondaryText}
        </Typography>
      ) : (
        ''
      )}
    </div>
  )
}
const DashboardSummaryCountsWidget = ({
  showLoader = false,
  summaryItems,
  syncInfo = {},
  useMockData = false
}: IProps): ReactElement => {
  const { status } = syncInfo

  const synStatus = useMockData ? DATASOURCE_STATUS.scanning : status

  return (
    <div
      className="dashboard-widget-summary-and-status"
      data-test-id="dashboard-summary-counts-widget"
    >
      <div className="summary-overview-container">
        {/* TODO: Find / Create i18 variable */}
        <div className="row" style={{ gap: '0.5rem' }}>
          <Typography className="font-600" as="span">
            <FormattedMessage id="dataSources.widget.overview.title" />
          </Typography>
          {synStatus &&
            (synStatus === DATASOURCE_STATUS.paused ||
              synStatus === DATASOURCE_STATUS.resuming) && (
              <Tags size={20} color="error">
                {<FormattedMessage id="dataSources.overview.scanStatus.paused.text" />}
              </Tags>
            )}
        </div>
        {}
        <div className="summary-counts">
          {summaryItems.map(
            ({ icon, text, secondaryText, count, content, link, tooltip, numberFormat }, index) => (
              <Fragment key={text}>
                {index > 0 && <div className="summary-separator" />}
                {link ? (
                  <Link to={link}>
                    <SummaryItem
                      icon={icon}
                      numberFormat={numberFormat}
                      {...(content ? { content } : { count: count || 0 })}
                      text={text}
                      secondaryText={secondaryText}
                      tooltip={tooltip}
                    />
                  </Link>
                ) : (
                  <SummaryItem
                    icon={icon}
                    numberFormat={numberFormat}
                    {...(content ? { content } : { count: count || 0 })}
                    text={text}
                    secondaryText={secondaryText}
                    tooltip={tooltip}
                  />
                )}
              </Fragment>
            )
          )}
        </div>
      </div>
      <LoaderView showLoader={showLoader} size="small" />
    </div>
  )
}

const mapStateToProps = (state: RootState) => ({
  syncInfo: state.syncInfo.data
})

export default connect(mapStateToProps, null)(DashboardSummaryCountsWidget)
